import { render, staticRenderFns } from "./LaporanStockGlobal.vue?vue&type=template&id=08f5e6f8&"
import script from "./LaporanStockGlobal.vue?vue&type=script&lang=js&"
export * from "./LaporanStockGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports